import { Form, Input, Button } from 'antd';
import { useSignup } from '@hooks/useSignup';
import { Container, AuthCard, LinkWrapper, StyledLink } from '../style';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';

const Signup = () => {
    const { form, loading, onFinish } = useSignup();

    return (
        <Container>
            <AuthCard title="Sign Up">
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please input your name!' }]}
                    >
                        <Input size="large" prefix={<UserOutlined />} placeholder="Name" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, message: 'Please input your email!' }]}
                    >
                        <Input size="large" prefix={<MailOutlined />} placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password size="large" prefix={<LockOutlined />} placeholder="Password" />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        rules={[{ required: true, message: 'Please confirm your password!' }]}
                    >
                        <Input.Password size="large" prefix={<LockOutlined />} placeholder="Confirm Password" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Sign Up
                        </Button>
                    </Form.Item>
                    <LinkWrapper>
                        <StyledLink to="/sign-in">Already have an account? Sign in</StyledLink>
                    </LinkWrapper>
                </Form>
            </AuthCard>
        </Container>
    );
};

export default Signup;

